import styled from "styled-components";
import theme from "../../styledTheme/styledTheme";

export const FixeMenuStyled = styled.div`
  position: absolute;
  background-color: transparent;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 25px 36px 25px 25px;
  width: ${theme.fixedMenuWidth};

  @media (max-width: 768px) {
    width: 100%;
  }
`;
